import { useState } from "react";
function useSegmentationState(initialState) {
    const [state, setState] = useState(initialState);
    const updateState = (updates)=>{
        setState((prev)=>({
                ...prev,
                ...updates
            }));
    };
    const updateValue = (updates)=>{
        setState((prev)=>({
                ...prev,
                value: {
                    ...prev.value,
                    ...updates
                }
            }));
    };
    const handleClear = ()=>{
        updateState({
            fieldId: void 0,
            conditionalType: void 0,
            value: {
                selected: [],
                input: void 0,
                date: void 0
            }
        });
    };
    return {
        state,
        updateState,
        updateValue,
        handleClear
    };
}
export { useSegmentationState };
